module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "address"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_address",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ADDRESS TO READERS")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("This book, based upon the life of the artist Robert Seymour and the extraordinary events surrounding the creation of Charles Dickens’s first novel, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Pickwick Papers")]), _vm._v(", departs, at certain points, from the ‘accepted’ origin of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Pickwick")]), _vm._v(", as put forward by Dickens and his publisher Edward Chapman. It does so for a good reason.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The accepted origin is not true.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc92affa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/address.vue
// module id = 69
// module chunks = 0